import Cookies from "js-cookie";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import {
  fetchUploadVideoDetail,
  isDropboxVideoPresent,
  uploadBmDenaliVideo,
  getVideoUploadUrl,
  uploadVideoToAWS,
  fetchVideoMetadata,
  fetchInstagramVideoMetadata,
} from "../../Pages/Home/home_actions";
import { validUrl } from "../../utilities";
import { receiveValidationErrors } from "../Errors/errorActions";
import Step3SuccessMessage from "./Step3SuccessMessage";
import Step2FetchDetails from "./Step2FetchDetails";
import ProcessCancel from "./ProcessCancel";
import LimitReached from "./LimitReached";
import Step1AddUrl from "./Step1AddUrl";
import "./Styles/VideoProcess.scss";
import { setAddCompetitorVideo } from "../../Pages/Video/VideoActions";
import UploadPersonalVideo from "./UploadPersonalVideo";
import { fetchAutoCompleteProductOrHashtagCategories } from "../../Pages/Product/productActions";
import { updateParams } from "../../Pages/Video/VideoActions";
import AlreadyVideoExistsMessage from "./AlreadyVideoExistsMessage";

const UploadVideoProcess = ({
  uploadVideoDetails,
  limitReachedModal,
  uploadVideoModal,
  setUploadVideoModal,
  setLimitReachedModal,
  getBrandDetails,
  onUploadSuccess = () => {},
  renderFromTutorial,
}) => {
  const [step1Modal, setStep1Modal] = useState(false);
  const [step2Modal, setStep2Modal] = useState(false);
  const [step3Modal, setStep3Modal] = useState(false);
  const [cancelModal, setCancelModal] = useState({
    status: false,
    cancelAt: "",
  });
  const [videoType, setVideoType] = useState("");
  const [videoUrls, setFormValues] = useState([""]);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [singleVideoDetail, setSingleVideoDetail] = useState({});
  const [productsOption, setProductsOption] = useState([]);
  const [successData, setSuccessData] = useState({});
  const [savedLoading, setSavedLoading] = useState(false);
  const [authorizeToken, setAuthorizationToken] = useState("");
  const [videoExistsMessage, setVideoExistsMessage] = useState(false);
  const [videoDownloadErrorMessage, setVideoDownloadErrorMessage] =
    useState("");
  // const [authorizationDropboxToken, setAuthorizationDropboxToken] =
  //   useState("");
  const [driveAccessToken, setDriveAccessToken] = useState("");
  const [chooserOpen, setChooserOpen] = useState(false);

  const location = useLocation();
  const redirectUri = `${window.location.origin}${location.pathname}`;
  const dispatch = useDispatch();

  const navbarStatsReducer = useSelector((state) => state.navbarStatsReducer);
  const isCategoryPage = useSelector(
    (state) => state.videoPageStates.isCategoryPage
  );
  const validationErrors = useSelector(
    (state) => state.errors.validationErrors
  );
  const { currentBrand: brandDetails } = navbarStatsReducer || {};
  const { addCompetitorVideo } = useSelector((state) => state.videoData);

  const videoCount = useSelector(
    (state) => state.navbarStatsReducer.counts.videos
  );
  const brandProducts = useSelector(
    (state) => state.autoCompleteProductOrHashtagList
  );
  const { data: productsList } = brandProducts || {};

  useEffect(() => {
    if (productsList) {
      const productsOption = productsList.map((k) => ({
        label: k.name,
        value: k.id,
      }));
      setProductsOption(productsOption);
    }
  }, [productsList]);

  useEffect(() => {
    if (videoType?.value) {
      dispatch(receiveValidationErrors({}));
    }
  }, [videoType, singleVideoDetail]);

  useEffect(() => {
    if (addCompetitorVideo) {
      setStep1Modal(true);
    }
  }, [addCompetitorVideo]);

  useEffect(() => {
    dispatch(fetchAutoCompleteProductOrHashtagCategories({}));
  }, []);

  const handleCancelAllProcess = () => {
    sessionStorage.removeItem("authorizationDropboxToken");
    //Clear all states
    setCancelModal(false);
    setStep1Modal(false);
    setStep2Modal(false);
    setVideoType(null);
    setFormValues([""]);
    setUploadVideoModal(false);
    //step2Modal-View/Edit Single Video Detail
    setSingleVideoDetail({});
    setProductsOption([]);
    dispatch(receiveValidationErrors({}));
    if (addCompetitorVideo) {
      dispatch(setAddCompetitorVideo(false));
    }
  };

  const handleClose = (status, cancelAt) => {
    const video_url = videoUrls.filter((i) => i)[0];
    setAuthorizationToken("");
    setDriveAccessToken("");
    if (cancelAt === "step1Modal") {
      if (!video_url) {
        setStep1Modal(false);
        handleCancelAllProcess();
      } else {
        if (
          validationErrors.video_url ===
          "This video currently exists in the dashboard."
        ) {
          setStep1Modal(false);
          handleCancelAllProcess();
        } else {
          setStep1Modal(status);
          setCancelModal({ status: true, cancelAt });
        }
      }
    }
    if (cancelAt === "step2Modal") {
      setStep2Modal(status);
      setCancelModal({ status: true, cancelAt });
    }
    if (cancelAt === "step3Modal") {
      setStep3Modal(status);
      handleCancelAllProcess(); //Clear all
    }
    if (cancelAt === "limitReached") {
      setLimitReachedModal(status);
    }
  };

  const handleCloseMessage = () => {
    setVideoExistsMessage(false);
    setVideoDownloadErrorMessage("");
  };

  const handleCancel = () => {
    // setAuthorizationDropboxToken("");
    setChooserOpen(false);
    if (cancelModal.cancelAt === "step1Modal") {
      setStep1Modal(true);
    }
    if (cancelModal.cancelAt === "step2Modal") {
      setStep2Modal(true);
    }
    setCancelModal(false);
  };

  const updateSwitch = ({ target }) => {
    if (
      target.name === "is_paid_or_sponsored" &&
      !singleVideoDetail.is_advertisement
    ) {
      setSingleVideoDetail({
        ...singleVideoDetail,
        is_paid_or_sponsored: target.checked,
      });
    }

    if (
      target.name === "is_advertisement" &&
      !singleVideoDetail.is_paid_or_sponsored
    ) {
      setSingleVideoDetail({
        ...singleVideoDetail,
        is_advertisement: target.checked,
      });
    }
  };

  const onChangeNotes = (event) => {
    setSingleVideoDetail({ ...singleVideoDetail, notes: event.target.value });
  };

  const handleChange = (i, e) => {
    const newFormValues = [...videoUrls];
    newFormValues[i] = e.target.value;
    setFormValues([...newFormValues]);
  };

  const handleChangeProduct = (i) => {
    const updatedItems = i.map((item) => {
      const words = item.label.split(" ");
      const capitalizedWords = words.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1)
      );
      const updatedLabel = capitalizedWords.join(" ");
      return { ...item, label: updatedLabel };
    });

    setSingleVideoDetail({
      ...singleVideoDetail,
      selectedProducts: updatedItems,
    });
  };

  const selectCompetitors = (i) => {
    setSingleVideoDetail({ ...singleVideoDetail, competitors: i });
  };

  const handleChangeCategory = (productCategory) => {
    setSingleVideoDetail({ ...singleVideoDetail, productCategory });
  };

  const validate = () => {
    let isValid = false;
    const video_url = videoUrls.filter((i) => i)[0];
    const { value: video_url_type } = videoType || {};
    const errors = {};
    if (!video_url) {
      errors.video_url = "Please enter the video URL.";
    } else if (!validUrl(video_url)) {
      errors.video_url = "Please enter a valid YouTube, TikTok, or Dropbox URL";
    } else if (video_url_type === "Dropbox") {
      const dropboxRegex =
        /^(https?:\/\/)(www\.)?dropbox\.com\/(s|scl)\/[a-zA-Z0-9_-]+(\/[^?]+)?/i;
      if (!dropboxRegex.test(video_url)) {
        errors.video_url = "Please enter a valid public Dropbox video URL.";
      }
    }

    if (!isEmpty(errors)) {
      dispatch(receiveValidationErrors(errors));
    } else {
      isValid = true;
    }

    return isValid;
  };

  const fetchDropboxVideoDetails = (videoId, video_url) => {
    dispatch(receiveValidationErrors({}));
    isDropboxVideoPresent(
      "/videos/dropbox_videos/dropbox_video_already_exists",
      videoId
    )
      .then((response) => {
        if (response && response[0] === "Success") {
          setSingleVideoDetail((prev) => ({
            ...prev,
            platform: "Dropbox",
            is_paid_or_sponsored: false,
            is_advertisement: false,
            tagValue: "",
            notes: "",
            selectedProducts: [],
            videoTags: [],
            enableNext: true,
            video_url,
            brand_name: brandDetails.name,
            video_desc: "",
            title: prev?.cd_name?.replace(/\.[^/.]+$/, ""),
            author_name: "",
          }));
          setStep1Modal(false);
          setStep2Modal(true);
          setFetchLoading(false);
        }
      })
      .catch((err) => {
        const errors = {};
        if (err.response.status === 404) {
          errors.video_url = err.response.data[0];
          dispatch(receiveValidationErrors(errors));
        }
        setFetchLoading(false);
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const validation = validate();
    const getUrl = {
      TikTok: "/videos/tiktok_videos/fetch_videos_details",
      YouTube: "/videos/youtube_videos/fetch_videos_details",
      Instagram: "/instagram_videos/fetch_videos_details",
      Facebook: "/videos/facebook_videos/fetch_videos_details",
    };
    const video_url = videoUrls.filter((i) => i)[0];
    const { value } = videoType || {};
    if (validation) {
      dispatch(fetchAutoCompleteProductOrHashtagCategories({}));
      setFetchLoading(true);
      if (value === "Instagram") {
        dispatch(receiveValidationErrors({}));
        fetchInstagramVideoMetadata(video_url)
          .then((response) => {
            setSingleVideoDetail({
              author_name: response?.data?.authorName,
              video_desc: response?.data?.videoDescription,
              thumbnail_url: response?.data?.videoThumbnail,
              video_url,
              platform: "Instagram",
              is_paid_or_sponsored: false,
              is_advertisement: false,
              tagValue: "",
              notes: "",
              selectedProducts: [],
              videoTags: [],
              enableNext: true,
              brand_name: brandDetails.name,
            });
            setStep1Modal(false);
            setStep2Modal(true);
            setFetchLoading(false);
          })
          .catch((err) => {
            setFetchLoading(false);
            const errors = {};
            if (err.response?.status === 404) {
              errors.video_url = err.response.data[0];
              dispatch(receiveValidationErrors(errors));
            }
          });
      } else if (value === "TikTok") {
        dispatch(receiveValidationErrors({}));
        fetchVideoMetadata({ video_url, platform: "Tiktok" }) //TODO
          .then((response) => {
            setSingleVideoDetail({
              is_paid_or_sponsored: false,
              is_advertisement: false,
              tagValue: "",
              notes: "",
              selectedProducts: [],
              videoTags: [],
              enableNext: false,
              brand_name: brandDetails.name,
              title: response.data.title,
              author_name: response.data.author,
              video_desc: response.data.video_desc,
              thumbnail_url: response?.data?.origin_cover_url,
              platform: "Tiktok",
              video_url: response?.data?.video_url,
              metadata: response?.data,
            });
            setStep1Modal(false);
            setStep2Modal(true);
            setFetchLoading(false);
          })
          .catch((err) => {
            setFetchLoading(false);
            const errors = {};
            if (
              err.response.status === 500 ||
              err.response.status === 404 ||
              err.response.status === 504
            ) {
              errors.video_url = err.response.data.message;
              dispatch(receiveValidationErrors(errors));
            }
          });
        dispatch(receiveValidationErrors({}));
      } else {
        dispatch(receiveValidationErrors({}));
        fetchUploadVideoDetail(getUrl[value], video_url)
          .then((response) => {
            setSingleVideoDetail({
              is_paid_or_sponsored: false,
              is_advertisement: false,
              tagValue: "",
              notes: "",
              selectedProducts: [],
              competitors: [],
              videoTags: [],
              enableNext: true,
              ...response,
              metadata: response,
            });
            setStep1Modal(false);
            setStep2Modal(true);
            setFetchLoading(false);
          })
          .catch((err) => {
            const errors = {};
            if (err.response.status === 404) {
              errors.video_url = err.response.data[0];
              dispatch(receiveValidationErrors(errors));
            }
            setFetchLoading(false);
          });
      }
    }
  };

  const updateVideoTags = (e) => {
    setSingleVideoDetail({ ...singleVideoDetail, videoTags: e });
  };

  const handleTagsInputChange = (e) => {
    setSingleVideoDetail({ ...singleVideoDetail, tagValue: e });
  };

  const onChangeFields = (e) => {
    setSingleVideoDetail({
      ...singleVideoDetail,
      [e.target.name]: e.target.value,
    });
  };

  const createOption = (label) => ({ label, value: label });

  const handleKeyDown = (event) => {
    const errors = {};

    if (!singleVideoDetail.tagValue) return;
    switch (event.key) {
      case "Enter":
      case ",":
        if (singleVideoDetail.tagValue) {
          const letters = /^[a-z0-9]+$/i;
          const onlyNumber = /^\d+$/;
          if (
            !singleVideoDetail.tagValue.match(letters) ||
            singleVideoDetail.tagValue.match(onlyNumber)
          ) {
            errors.tagValueError = "Please enter a valid Tag";
          }
        }

        if (isEmpty(errors)) {
          setSingleVideoDetail({
            ...singleVideoDetail,
            tagValue: "",
            videoTags: [
              ...singleVideoDetail.videoTags,
              createOption(singleVideoDetail.tagValue),
            ],
          });
          event.preventDefault();
          dispatch(receiveValidationErrors({}));
        } else {
          dispatch(receiveValidationErrors(errors));
        }
    }
  };

  const validateFields = () => {
    let isValid = false;
    const errors = {};
    const letters = /^[\w\-\s]+$/;
    if (singleVideoDetail.notes) {
      if (!singleVideoDetail.notes.match(letters)) {
        errors.notesError = "Please enter valid note";
      }
    }
    if (addCompetitorVideo && !singleVideoDetail.competitors?.length) {
      errors.competitor = "Please assign video to competitor";
    }
    if (isEmpty(errors)) {
      isValid = true;
    } else {
      dispatch(receiveValidationErrors(errors));
    }
    return isValid;
  };

  const validateEnableNext = () => {
    let isValid = false;
    const errors = {};
    if (singleVideoDetail.platform === "Dropbox") {
      if (singleVideoDetail.title?.length < 1) {
        errors.title = "Video title is required";
      }
      if (isEmpty(errors)) {
        isValid = true;
        dispatch(receiveValidationErrors({}));
      } else {
        dispatch(receiveValidationErrors(errors));
      }
    }
    return isValid;
  };

  const ShouldNextEnable = (e) => {
    if (singleVideoDetail.platform === "Dropbox") {
      const shouldEnable = validateEnableNext();
      if (shouldEnable) {
        setSingleVideoDetail({ ...singleVideoDetail, enableNext: e });
      }
    } else {
      setSingleVideoDetail({ ...singleVideoDetail, enableNext: e });
    }
  };

  const onVideoAdded = (videoResponse) => {
    if (location?.pathname?.includes("videos") && !isCategoryPage) {
      dispatch(updateParams({ reFetch: true }));
    }
    setStep2Modal(false);
    setStep3Modal(true);
    setSavedLoading(false);
    getBrandDetails();
    localStorage.setItem("vidUploadedInSession", true);
    onUploadSuccess(singleVideoDetail);
    // dispatch(fetchNavbarStats());
    // dispatch(fetchHomePage());
    if (videoCount === 0) {
      localStorage.setItem(
        "firstVideoAnalysisId",
        `${videoResponse?.data?.videoId},pending`
      );
    }
  };

  const handleSuccess = (event) => {
    // Saving video
    const fieldsValidation = validateFields();
    event.preventDefault();
    // setAuthorizationDropboxToken("");
    if (fieldsValidation) {
      const videoTagsFormat = singleVideoDetail?.videoTags?.map(
        (item) => item.label
      );
      const product_ids = singleVideoDetail?.selectedProducts
        ?.filter((item) => !item.__isNew__) // Filter out items with _isNew__ true
        .map((item) => item.value);

      let title = singleVideoDetail.title;
      if (singleVideoDetail.platform === "Dropbox") {
        const fileExtention = singleVideoDetail.cd_name.split(".");
        const extension = fileExtention[fileExtention.length - 1];
        title = `${singleVideoDetail.title}.${extension}`;
      }
      const authorizationDropboxToken = sessionStorage.getItem(
        "authorizationDropboxToken"
      );
      const appendDropboxField = {
        title,
        video_desc: singleVideoDetail.video_desc,
        author_name: singleVideoDetail.author_name,
        cd_bytes: singleVideoDetail.cd_bytes,
        cd_id: singleVideoDetail.cd_id,
        cd_isDir: singleVideoDetail.cd_isDir,
        cd_link: singleVideoDetail.cd_link,
        authorizeToken: authorizationDropboxToken,
        redirectUri,
      };
      const appendGoogleDriveField = {
        title,
        video_desc: singleVideoDetail.video_desc,
        author_name: singleVideoDetail.author_name,
        video_id: singleVideoDetail.id,
        thumbnail_url: singleVideoDetail.thumbnail_url,
        driveAccessToken,
        authorizeToken,
        redirectUri,
      };
      const { value } = videoType || {};

      const platformValue = {
        TikTok: "Tiktok",
        YouTube: "Youtube",
        Facebook: "facebook",
        Instagram: "Instagram",
        Dropbox: "Dropbox",
        GoogleDrive: "GoogleDrive",
        localVideo: "localVideo",
      };

      const newProducts = singleVideoDetail.selectedProducts
        .filter((item) => item.__isNew__)
        .map((item) => item.label);

      const sendData = {
        is_paid_or_sponsored: singleVideoDetail.is_paid_or_sponsored,
        is_advertisement: singleVideoDetail.is_advertisement,
        productIds: product_ids,
        newProducts,
        video_tags: videoTagsFormat,
        notes: singleVideoDetail.notes,
        videoUrl:
          singleVideoDetail.platform === "Dropbox" ||
          singleVideoDetail.platform === "Tiktok"
            ? singleVideoDetail.video_url
            : videoUrls[0],
        platform: platformValue[value],
        brandIds: [Cookies.get("bId")],
        user_id: Cookies.get("uId"),
        productCategory: singleVideoDetail?.productCategory?.value,
        selected_image:
          singleVideoDetail.platform === "Dropbox"
            ? ""
            : singleVideoDetail.thumbnail_url,
        ...(singleVideoDetail.platform === "Dropbox"
          ? appendDropboxField
          : {} || singleVideoDetail.platform === "GoogleDrive"
          ? appendGoogleDriveField
          : {}),
        categoryIds: singleVideoDetail?.productCategory?.value
          ? [singleVideoDetail?.productCategory?.value]
          : [],
        metadata: singleVideoDetail.metadata,
        uploadMethod:
          singleVideoDetail.platform === "localVideo"
            ? "InternalDashboard-video-upload"
            : "InternalDashboard-video-submit",
      };

      if (addCompetitorVideo) {
        sendData.competitorVideo = true;
        sendData.competitors =
          singleVideoDetail?.competitors?.map((i) => ({
            competitor: i.value,
            isnew: i.__isNew__,
          })) || [];
      } else {
        sendData.is_paid_or_sponsored = singleVideoDetail.is_paid_or_sponsored;
        sendData.is_advertisement = singleVideoDetail.is_advertisement;
      }

      if (singleVideoDetail.platform === "localVideo") {
        sendData.title = singleVideoDetail.title;
      }
      if (
        singleVideoDetail?.platform === "Instagram" &&
        sendData?.videoUrl?.includes("/p/")
      ) {
        sendData.videoUrl = sendData?.videoUrl?.replace("/p/", "/reel/");
      }
      const jsonData = {};
      Object.keys(sendData).forEach((key) => {
        jsonData[key] = sendData[key];
      });
      const formData = JSON.stringify(jsonData);
      setSavedLoading(true);
      const getUrl = {
        TikTok: "/videos/tiktok_videos",
        YouTube: "/videos/youtube_videos",
        InstaGram: "/videos/instagram_videos",
        FaceBook: "/videos/facebook_videos",
        Dropbox: "/videos/dropbox_videos",
      };
      if (singleVideoDetail.platform === "localVideo") {
        const mimeTypes = {
          "video/mp4": "mp4",
          "video/MP4": "mp4",
          "video/mov": "mov",
          "video/quicktime": "mov",
        };
        getVideoUploadUrl(formData, mimeTypes[singleVideoDetail.file.type])
          .then((response) => {
            if (response.status === 200) {
              uploadVideoToAWS(response.data.uploadURL, singleVideoDetail.file)
                .then((videoResponse) => {
                  if (videoResponse.status === 200) {
                    onVideoAdded(videoResponse);
                    setSuccessData({
                      platform: sendData.platform,
                      video_url: singleVideoDetail.video_url,
                      thumbnail_url: singleVideoDetail.thumbnail_url,
                    });
                  }
                })
                .catch(() => {
                  dispatch(
                    receiveValidationErrors({
                      uploadVideo: "Failed to upload video",
                    })
                  );
                });
            }
          })
          .catch(() => {
            dispatch(
              receiveValidationErrors({ uploadVideo: "Failed to upload video" })
            );
          });
      } else {
        uploadBmDenaliVideo({ formData, url: getUrl[value] })
          .then((response) => {
            const { videoId, video_already_exists } = response?.data;
            if (!isEmpty(videoId)) {
              if (video_already_exists) {
                setVideoExistsMessage(true);
                setVideoDownloadErrorMessage("");
                setStep2Modal(false);
                setSavedLoading(false);
                setChooserOpen(false);
              } else {
                onVideoAdded(response);
                setSuccessData({
                  platform: sendData.platform,
                  video_url: sendData.videoUrl,
                  thumbnail_url: singleVideoDetail.thumbnail_url,
                });
                setAuthorizationToken("");
                setDriveAccessToken("");
                setChooserOpen(false);
                if (videoCount === 0) {
                  localStorage.setItem("toturialScreen", "firstVideo");
                }
              }
            }
          })
          .catch((error) => {
            setSavedLoading(false);
            if (
              error.response.status === 404 &&
              error.response.data[0] === "Video upload max limit reached"
            ) {
              handleCancelAllProcess();
              setLimitReachedModal(true);
              getBrandDetails();
            }

            if (
              error.response.status === 400 &&
              error?.response?.data?.message
            ) {
              setVideoExistsMessage(true);
              setVideoDownloadErrorMessage(error?.response?.data?.message);
            }
          });
      }
      dispatch(receiveValidationErrors({}));
    }
  };

  const onDropboxSuccess = (files) => {
    setUploadVideoModal(false);
    setVideoType({ value: "Dropbox" });
    setFormValues([files?.[0].link]);
    // Getting from chooser dropbox
    setSingleVideoDetail({
      cd_bytes: files?.[0].bytes,
      cd_icon: files?.[0].icon,
      cd_id: files?.[0].id,
      cd_isDir: files?.[0].isDir,
      cd_link: files?.[0].link,
      cd_linkType: files?.[0].linkType,
      cd_name: files?.[0].name,
      cd_thumbnailLink: files?.[0].thumbnailLink,
      metadata: files?.[0],
    });
    fetchDropboxVideoDetails(files?.[0].id, files?.[0].link);
  };

  const fileHandler = (file) => {
    if (file) {
      setVideoType({ value: "localVideo" });
      setSingleVideoDetail({
        file,
        video_url: URL.createObjectURL(file),
        platform: "localVideo",
        is_paid_or_sponsored: false,
        is_advertisement: false,
        tagValue: "",
        notes: "",
        selectedProducts: [],
        videoTags: [],
        enableNext: true,
        brand_name: brandDetails.name,
        video_desc: "",
        title: file.name,
        author_name: "",
      });
      setStep2Modal(true);
      setUploadVideoModal(false);
    }
  };

  const stepBackHandler = () => {
    if (
      singleVideoDetail.platform === "Tiktok" ||
      singleVideoDetail.platform === "Youtube" ||
      singleVideoDetail.platform === "Instagram" ||
      singleVideoDetail.platform === "facebook"
    ) {
      setStep1Modal(true);
      setUploadVideoModal(false);
    } else {
      setStep1Modal(false);
      setUploadVideoModal(true);
    }
    setAuthorizationToken("");
    setDriveAccessToken("");
    setProductsOption([]);
    setCancelModal(false);
    setStep2Modal(false);
    dispatch(receiveValidationErrors({}));
  };

  const onGoogleDriveSuccess = (videoData) => {
    setUploadVideoModal(false);
    // setAuthorizationToken("");
    // setDriveAccessToken("");
    setVideoType({ value: "GoogleDrive" });
    setFormValues([videoData.url]);
    setStep2Modal(true);
    // Getting from Google Drive
    setSingleVideoDetail({
      ...singleVideoDetail,
      name: videoData.name,
      embedUrl: videoData.embedUrl,
      thumbnail_url: `https://drive.google.com/thumbnail?id=${videoData.id}`,
      url: videoData.url,
      id: videoData.id,
      enableNext: true,
      platform: "GoogleDrive",
      is_paid_or_sponsored: false,
      is_advertisement: false,
      tagValue: "",
      notes: "",
      selectedProducts: [],
      videoTags: [],
      brand_name: brandDetails.name,
      video_desc: videoData?.description || "",
      title: videoData.name.replace(/\.[^/.]+$/, ""),
      author_name: "",
    });
  };

  return (
    <div className="VideosProcess">
      <UploadPersonalVideo
        uploadVideoModal={uploadVideoModal}
        setUploadVideoModal={setUploadVideoModal}
        setStep1Modal={setStep1Modal}
        fileHandler={fileHandler}
        onDropboxSuccess={onDropboxSuccess}
        onGoogleDriveSuccess={onGoogleDriveSuccess}
        redirectUri={redirectUri}
        setAuthorizationToken={setAuthorizationToken}
        driveAccessToken={driveAccessToken}
        setDriveAccessToken={setDriveAccessToken}
        setChooserOpen={setChooserOpen}
        chooserOpen={chooserOpen}
      />
      <Step1AddUrl
        open={step1Modal}
        videoUrls={videoUrls}
        videoType={videoType}
        fetchLoading={fetchLoading}
        singleVideoDetail={singleVideoDetail}
        uploadVideoDetails={uploadVideoDetails}
        handleClose={handleClose}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        setVideoType={setVideoType}
        onDropboxSuccess={onDropboxSuccess}
        onGoogleDriveSuccess={onGoogleDriveSuccess}
        setSingleVideoDetail={setSingleVideoDetail}
        clearFieldError={() => dispatch(receiveValidationErrors({}))}
        setStep1Modal={setStep1Modal}
        setUploadVideoModal={setUploadVideoModal}
      />
      {step2Modal && (
        <Step2FetchDetails
          open={step2Modal}
          savedLoading={savedLoading}
          productsOption={productsOption}
          singleVideoDetail={singleVideoDetail}
          handleClose={handleClose}
          updateSwitch={updateSwitch}
          handleSuccess={handleSuccess}
          onChangeNotes={onChangeNotes}
          handleKeyDown={handleKeyDown}
          onChangeFields={onChangeFields}
          stepBackHandler={stepBackHandler}
          updateVideoTags={updateVideoTags}
          ShouldNextEnable={ShouldNextEnable}
          handleChangeProduct={handleChangeProduct}
          handleChangeCategory={handleChangeCategory}
          handleTagsInputChange={handleTagsInputChange}
          addCompetitorVideo={addCompetitorVideo}
          selectCompetitors={selectCompetitors}
        />
      )}
      <Step3SuccessMessage
        open={step3Modal}
        successData={successData}
        handleClose={handleClose}
      />
      <AlreadyVideoExistsMessage
        open={videoExistsMessage}
        singleVideoDetail={singleVideoDetail}
        handleClose={handleCloseMessage}
        videoDownloadErrorMessage={videoDownloadErrorMessage}
      />

      <ProcessCancel
        open={cancelModal.status}
        handleCancel={handleCancel}
        handleCancelAllProcess={handleCancelAllProcess}
      />
      <LimitReached open={limitReachedModal} handleClose={handleClose} />
    </div>
  );
};

export default UploadVideoProcess;
